export default __webpack_public_path__ + "static/media/Rule5.2e2651cd.png";